import React from 'react';

import Button from '@atlaskit/button';

import { IS_CLOUD } from '@qality/common-config';
import { CreateTestCycleDialogRenderer } from '@qality/server-renderers';

import { Gadget, GadgetHeader } from '../gadgets.styled';
import { RecentTestCyclesView } from './RecentTestCycles.view';
import RecentTestCyclesConfigView from './RecentTestCyclesConfig.view';
import { RecentTestCyclesProvider } from './RecentTestCyclesProvider';

interface RecentTestCyclesProps {
  projectId: string;
  isQAlityConfigured: boolean;
}

const RecentTestCycles: React.FC<RecentTestCyclesProps> = ({
  projectId,
  isQAlityConfigured,
}: RecentTestCyclesProps) => {
  const handleOpenDialog = () => {
    if (IS_CLOUD) {
      window.AP.dialog.create({
        key: 'create-test-cycle-dialog',
        size: 'maximum',
        chrome: false,
      });
    } else {
      CreateTestCycleDialogRenderer.openCreateTestCycleDialog();
    }
  };

  return (
    <RecentTestCyclesProvider projectIds={projectId}>
      <>
        <GadgetHeader>
          <h4>Recent Test Cycles</h4>
          <div>
            <Button
              onClick={handleOpenDialog}
              appearance='default'
              isDisabled={!isQAlityConfigured}
            >
              Create Test Cycle
            </Button>
          </div>
        </GadgetHeader>
        <Gadget>
          {isQAlityConfigured ? (
            <RecentTestCyclesView />
          ) : (
            <RecentTestCyclesConfigView />
          )}
        </Gadget>
      </>
    </RecentTestCyclesProvider>
  );
};

export default RecentTestCycles;
